import type { FAQItem } from "../../../components/common/FAQ";

export const GENERAL_FAQ: FAQItem[] = [
  {
    question:
      "Does Alpaca charge fees to transfer money in or out of my account?",
    answer: (
      <>
        ACH deposits / withdrawals are free. Incoming wires are free. Outgoing
        wires cost $25 (domestic) or $50 (international) per transaction. Local
        Currency Transfers have 1.5% fee per transaction. Please see the{" "}
        <a
          href="https://files.alpaca.markets/disclosures/library/BrokFeeSched.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Fee Schedule
        </a>
        .
      </>
    ),
  },
  {
    question: "Is there an account minimum for live brokerage accounts?",
    answer: <>No minimums for accounts at this time.</>,
  },
  {
    question: "Can I fund my account using a debit card or credit card?",
    answer: <>Debit and credit card funding is not available at this time.</>,
  },
  {
    question: "How can a domestic user (US Tax Resident) fund their account?",
    answer: (
      <>
        Alpaca supports direct bank (ACH) transfers, wire transfers and
        portfolio transfers from other DTC participants (ACATS).
      </>
    ),
  },
  {
    question:
      "How can an international user (Non-US Tax Resident) fund their account?",
    answer: (
      <>
        International users can fund their accounts via international wire or
        local currency using CurrencyCloud.
      </>
    ),
  },
  {
    question: "Is my account insured? What is SIPC?",
    answer: (
      <>
        Alpaca Securities LLC is a member of the Securities Investor Protection
        Corporation (SIPC), which protects customer securities accounts up to
        $500,000, including up to $250,000 for cash claims.
        <br />
        <br />
        In addition to SIPC protection, Alpaca Securities LLC carries Excess
        SIPC coverage through Lloyd&#39;s of London, which provides supplemental
        protection if SIPC limits are exhausted. Subject to policy terms and
        conditions, this excess coverage provides additional protection up to a
        $75 million per-customer sub-limit for combined securities and cash
        claims, including up to $30.5 million for securities and $1.25 million
        for cash, reduced by applicable net equity receipts. The policy has a
        $250 million aggregate limit across all Alpaca customer accounts and,
        like SIPC coverage, does not protect against market losses.
        <br />
        <br />
        For further details please see:{" "}
        <a
          href="https://files.alpaca.markets/disclosures/library/SIPC%20and%20Excess%20SIPC%20Protection.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          SIPC and Excess SIPC Protection
        </a>
      </>
    ),
  },
];
